import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, CHECKOUT_URL, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-b border-line bg-surface/40" data-id="element-96" data-mp="8llse5x8lrfg">
      <div className="mx-auto max-w-xl px-4 py-8 sm:py-10" data-id="element-97" data-mp="idzx97jm3e5u">
        <SectionHeader id="oferta-titulo" eyebrow="Oferta especial — Sistema completo 6 en 1" eyebrowTone="danger" title="Comienza hoy desde cero y avanza a tu ritmo." data-id="element-98" data-mp="ifkpurmd8n12" />

        <div className="mt-5 rounded-2xl border-[3px] border-dashed border-accent bg-surface p-5 text-center shadow-[0_0_0_6px_rgb(255_214_0/0.08)]" data-id="element-99" data-mp="wcr6ognj4bnn">
          <p className="font-display text-sm font-extrabold text-accent sm:text-base" data-id="element-100" data-mp="2t6ued3vv93lb">
            ⚡ {PRODUCT_NAME}
          </p>
          <p className="mt-1 flex items-center justify-center gap-1.5 font-display text-sm font-semibold text-ink" data-id="element-101" data-mp="2y67888l5naxe">
            <CheckIcon size={16} aria-hidden="true" className="text-success" data-id="element-102" data-mp="xx1xtvo4ug4h" />
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-sm font-medium text-ink" data-id="element-103" data-mp="swxdfuk3t18z">🎁 Bonos valorados en {BONUS_TOTAL}</p>

          <p className="mx-auto mt-3 inline-block rounded-md bg-danger px-3 py-1 font-display text-xs font-extrabold uppercase text-ink" data-id="element-104" data-mp="owwt5tabpvu0">
            🔥 Oferta especial
          </p>
          <p className="mt-2 font-display text-4xl font-extrabold text-ink sm:text-5xl" data-id="element-105" data-mp="1gmrt0jvt53wx">
            Hoy: <span className="text-accent" data-id="element-106" data-mp="1clg28b176cn5">{PRICE}</span>
          </p>
          <p className="mt-1 text-xs font-medium text-muted sm:text-sm" data-id="element-107" data-mp="1cnsmwvycb13w">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-108" data-mp="16swk5vjywci">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>
          <p className="mt-2 text-xs text-muted" data-id="element-109" data-mp="3sbj2aa6fca4x">Acceso Inmediato • Garantía de 7 Días</p>
        </div>
      </div>
    </section>;
}